export enum DiscountType {
	PERCENTAGE = "PERCENTAGE",
	FIXED_AMOUNT = "FIXED_AMOUNT",
}
